import { Box } from '@mui/material';
import { DroppedImage } from 'pages/InputBox';
import React from 'react';
import { useDropzone } from 'react-dropzone';

interface Props {
  image: DroppedImage;
  setImage: React.Dispatch<React.SetStateAction<DroppedImage>>;
}

function DropZoneComponent({ image, setImage }: Props) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/png': [],
      'image/gif': [],
      'image/jpeg': [],
      'image/webp': [],
    },
    multiple: false,
    onDrop: (acceptedFiles: File[]) => {
      convertToBase64(acceptedFiles[0]);
    },
  });
  const convertToBase64 = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const imageFile = {
        name: file.name,
        lastModified: file.lastModified,
        lastModifiedDate: new Date(file.lastModified),
        size: file.size,
        type: file.type,
        base64: reader.result as string,
      };
      setImage(imageFile);
    };
    reader.onerror = error => {
      console.error('Error converting file to base64:', error);
    };
  };

  return (
    <Box
      sx={{
        position: 'relative',
        flexGrow: 1,
        width: '100%',
        height: '100%',
        border: '2px dashed var(--black01)',
        padding: '10px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ':hover': {
          border: '2px dashed var(--primary)',
        },
        bgcolor: isDragActive ? 'var(--primary05)' : undefined,
      }}
      {...getRootProps({ className: 'container' })}
      className='container'
    >
      <input {...getInputProps()} style={{ position: 'absolute', width: '100%', height: '100%' }} hidden />
      {!image ? (
        <div {...getRootProps({ className: 'dropzone' })}>
          <p className='noselect'>Click or Drag &apos;n&apos; drop some files here</p>
        </div>
      ) : (
        <Box className='file-labels' sx={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden', overflowX: 'scroll' }}>
          {image.name} - {image.size} bytes
        </Box>
      )}
    </Box>
  );
}

export default DropZoneComponent;
